// import { type TeamLogoProps } from "components-sbk/src/components/TeamLogo/types" -- fix this import of SBK related things in Core;
import { type IconProps } from "components/src/components//Icon/types";
import { getTeamInfo, TeamInfoReturnType } from "shared/src/hooks/getTeamInfo";
import { isValidIcon } from "shared/src/hooks/useImageResolver";

type _IconStringPropsType = Partial<IconProps>;
export type CustomIconStringReturnElementsType = {
  isTeam?: boolean;
  name: string;
  isUrl?: boolean;
  isIcon?: boolean;
  league?: string;
  foundTeam?: TeamInfoReturnType;
  category?: string;
}; 
export type IconStringPropsType = _IconStringPropsType &
  CustomIconStringReturnElementsType;
export type IconStringReturnType = CustomIconStringReturnElementsType | null;

export function isValidIconString(str) {
  if (typeof str !== "string") return false;
  return str && str.includes("###");
}

const httpsRE = /^https?/;

export function parseIconString(
  iconStr: string
): IconStringReturnType | IconStringReturnType[] {
  if (typeof iconStr !== "string" || iconStr === "") return null;

  if (iconStr.includes("@")) {
    const iconStrs = iconStr.split("@");
    return iconStrs.map((s) => parseStr(s)) as IconStringReturnType[];
  }

  return parseStr(iconStr) as IconStringReturnType;
}

function parseStr(iconStr) {

  const _iconStr = iconStr.split("###");

  // Regular icon string name
  if (_iconStr.length === 1) {
    const isUrl = httpsRE.test(_iconStr[0]);
    const foundTeam = getTeamInfo(_iconStr[0]);

    if (foundTeam)
      return {
        name: foundTeam.name,
        isIcon: false,
        isUrl: false,
        isTeam: true,
        league: foundTeam.league,
        foundTeam,
      };
    if (isUrl)
      return {
        name: _iconStr[0],
        isIcon: false,
        isUrl,
        isTeam: false,
        league: undefined,
      };
      console.log({ validIcon: isValidIcon(_iconStr[0]), _iconStr: _iconStr[0]})
    return isValidIcon(_iconStr[0])
      ? {
          name: _iconStr[0],
          isIcon: true,
          isUrl: false,
          isTeam: false,
          league: undefined,
        }
      : null;
  }

  // Formatted icon string name with ### delimiter
  const [category = "", name = "", league = ""] = _iconStr;
  const foundTeam = getTeamInfo(name);
  const isTeam = /team/gi.test(category) && !!foundTeam;
  const isUrl = httpsRE.test(name) || /^\/\//.test(name) || category === "url";

  return {
    name,
    isUrl,
    isTeam,
    isIcon: isValidIcon(name),
    league,
    foundTeam,
    category,
  };
}

export default parseIconString;